import { useState } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import ActiveApplications from './-components/active-applications'
import ApplicationHistoryTab from './-components/application-history'
import SavedJobsTab from './-components/saved-jobs'

export const Route = createFileRoute('/dashboard/job-history')({
  component: RouteComponent,
})

function RouteComponent() {
  const [activeTab, setActiveTab] = useState('Lamaran Aktif')

  const tabs = [
    'Lamaran Aktif',
    'Tersimpan',
    // 'Riwayat Lamaran'
  ]

  return (
    <>
      <div className="min-h-screen bg-gray-50">
        {/* Header Tabs */}
        <div className="border-b border-gray-200 bg-white">
          <div className="mx-auto max-w-4xl px-4">
            <div className="flex space-x-8">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`border-b-2 px-2 py-4 text-sm font-medium transition-colors duration-200 ${
                    activeTab === tab
                      ? 'border-red-500 text-red-600'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="mx-auto max-w-4xl px-4 py-6">
          {/* Tab Content */}
          {activeTab === 'Lamaran Aktif' && <ActiveApplications />}
          {activeTab === 'Tersimpan' && <SavedJobsTab />}
          {activeTab === 'Riwayat Lamaran' && <ApplicationHistoryTab />}
        </div>
      </div>
    </>
  )
}
